@import 'src/global/theme-variables';

.rv-container {
  display: flex;
  padding: 16px;
  position: relative;
  border: 1px solid #eee;
  border-radius: 7px;
  flex-direction: column;
  justify-content: space-between;
  width: auto;

  p {
    margin-block: 0;
  }

  * {
    font-family: Inter, Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue',
      Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  }
}

.rv-header-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.rv-tax-benchmarking-container {
  width: 100%;
  height: 100%;
}

.rv-title {
  display: flex;
  color: $secondary;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  padding: 0;
  text-align: left;
  flex-grow: 1;
  line-height: 1.235;
  align-items: baseline;
}

.rv-chart-percentage {
  visibility: inherit;
  -webkit-font-smoothing: antialiased;
  margin: 0;
  line-height: 1.5;
  display: flex;
  flex-direction: row;
  font-size: 14px;
  font-weight: 500;
  padding-left: 8px;

  .rv-positive {
    color: $positive;
  }

  .rv-negative {
    color: $negative;
  }
}

.rv-score-last-updated {
  align-self: center;
  text-align: center;
  font-size: 12px;
  color: #757575;
  font-weight: 500;
  line-height: 28px;
}

.rv-tax-benchmarking-group {
  margin-top: 24px;
}

.rv-tax-benchmarking-business-info {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 600;
  color: #424242;
}

.table-container {
  overflow-x: auto;
  width: 100%;
}

.benchmarking-table {
  border-collapse: collapse;
  width: 100%;
  margin-top: 24px;
}

th,
td {
  padding: 16px;
  text-align: left;
}

.table-header {
  font-size: 12px;
  font-weight: 600;
  color: #424242;
}

.header-with-tooltip {
  display: flex;
}

tr {
  border-bottom: 1px solid #ddd;
}

select {
  border: none;
  background-color: transparent;
  font-size: 1rem;
  font-family: inherit;
  cursor: pointer;
}

// select:focus {
//   outline: none;
// }

option {
  background-color: white;
  font-size: 1rem;
  font-family: inherit;
}

option:checked {
  font-weight: bold;
}
